<template>
  <div
    id="compreSportsMeet_schedule"
    v-show="currThemeObj"
    :class="isShowNotData ? 'isShow' : ''"
  >
    <NOT_DATA
      :className="'relativePtb60'"
      v-if="matchDateArr && matchDateArr.length == 0"
    />
    <template v-else>
      <div class="select_area" v-show="matchDateArr && matchDateArr.length > 0">
        <marathon_select_opt
          :currThemeObj="currThemeObj"
          :data="selectOptData"
          @changeSelectEvent="changeSelect"
        ></marathon_select_opt>
      </div>
      <div class="teamTable">
        <div class="tableScrollArea" ref="tableParentDom">
          <div class="match_label_fixed" v-show="curMatchLabelFixedIcon">
            <div class="match_label">
              <span class="label_textArea">
                <span class="labelIcon">
                  <img
                    :src="`/static/${currThemeObj.sportType}/${currThemeObj.imageUrl}/sportsIcon/${currBigSports.icon}.png`"
                  />
                </span>
                <span
                  :class="[
                    currBigSports.label && currBigSports.label.length === 2
                      ? 'letterSpa'
                      : '',
                  ]"
                  v-text="currBigSports.label"
                ></span>
              </span>
            </div>
          </div>
          <div :class="scrollDomClassName">
            <schedule_group_matchList
              v-for="item in matchList"
              :currCid="currCid"
              :currSid="currSid"
              :key="item.icon"
              :currThemeObj="currThemeObj"
              :data="item"
              :pbPx="matchItemPbpx"
            >
              <template v-slot:matchList>
                <schedule_match_list
                  :currCid="currCid"
                  :currSid="currSid"
                  :currThemeObj="currThemeObj"
                  :data="item.list"
                  :detailPathName="'CSMeetSportDetailScheduleDetailDataAnalysis'"
                  :chooseState="'default'"
                  :matchModeObj="scheduleMatchList_matchMode"
                />
              </template>
            </schedule_group_matchList>
          </div>
          <p class="loadingClass" v-show="loading">加载中...</p>
          <p class="noMoreClass" v-show="noMore">没有更多了</p>
          <p class="noDataClass" v-show="noData">暂无数据</p>
        </div>
      </div>
    </template>
    <BackTop :showBackTop="showBackTop" :clickEvent="goBackTop"></BackTop>
  </div>
</template>

<script>
import {
  https_delegationDetail_schedule,
  https_delegation_select_dateBigSports,
} from '@api/platfrom_compreSportsMeet_api'
import NOT_DATA from '@components/base/NO_DATA.vue'
import BackTop from '@components/base/backTop.vue'
import marathon_select_opt from '@components/platfromBase/marathon/select_opt.vue'
import schedule_group_matchList from '@components/platfromBase/compreSportsMeet/schedule_group_matchList.vue'
import schedule_match_list from '@components/platfromBase/generalComponents/scheduleMatchList_compex/index.vue'
import cup_base_data_mixin from '@mixins/cup_base_data'

export default {
  name: 'compreSportsMeet_schedule',
  components: {
    marathon_select_opt,
    schedule_group_matchList,
    schedule_match_list,
    NOT_DATA,
    BackTop,
  },
  mixins: [cup_base_data_mixin],
  props: {
    sportsTypeArr: {
      type: Array,
      default: () => {
        return []
      },
    },
    bigSportsList: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  data() {
    return {
      isScrollBottom: false,
      firstPageIsScrollBottom: false,
      scrollDomClassName: 'scrollDomContain',
      scrollDomById: 'containerFull_body',
      loading: false,
      curMatchLabelFixedIcon: null,
      matchItemPbpx: 0,
      matchLabelArr: [],
      matchList: null,
      matchTotal: 0,
      currStageMatchDate: '',
      currStageBigSports: '',
      curInputVal: '',
      pnum: 1,
      psize: 20,
      matchDateArr: null,
      bigSportsArr: [],
      selectAllObj: {
        value: '',
        name: '全部',
      },
      selectOptData_origin: {
        configArr: [
          {
            type: 'matchDate',
            title: '日期',
            origin_keyVal: ['value', 'name'],
            dataName: 'matchDateArr',
            selectIndex: 0,
          },
          {
            type: 'bigSports',
            title: '项目',
            origin_keyVal: ['value', 'name'],
            dataName: 'bigSportsArr',
            selectIndex: 0,
          },
        ],
        selectOpt_list: [],
      },
      selectOptData: null,
      showBackTop: false,
      scheduleMatchList_matchMode: {
        mode: 'compreSportsMeet',
      },
    }
  },
  beforeCreate() {},
  created() {
    // this.query = this.$route.query
    this.initPbPx()
    this.init()
  },
  beforeDestroy() {
    window.removeEventListener('resize', () => {
      this.onResizeEvent()
    })
  },
  computed: {
    currBigSports() {
      let label = ''
      this.bigSportsList.forEach((item) => {
        if (item.id === this.curMatchLabelFixedIcon) {
          label = item.CN
        }
      })
      return {
        label: label,
        icon: this.curMatchLabelFixedIcon,
      }
    },
    isShowNotData() {
      return this.matchDateArr && this.matchDateArr.length == 0
    },
    noMore() {
      // return (
      //   this.matchTotal !== 0 &&
      //   (this.isScrollBottom || this.firstPageIsScrollBottom)
      // )
      return this.matchTotal !== 0
    },
    noData() {
      return this.matchDateArr && this.matchTotal === 0 && this.matchList
    },
    tableHeightPx() {
      let clientHeight = window.innerHeight
        ? window.innerHeight
        : window.screen.height
        ? window.screen.height
        : 667
      let clientWidth = window.innerWidth
        ? window.innerWidth
        : window.screen.width
        ? window.screen.width
        : 375

      return Math.floor(clientHeight - (clientWidth / 100) * (42 - 26))
      // return 500
    },
  },
  methods: {
    async init() {
      window.mixtmtBase_eventBus.$emit('loadingEvent', true)
      this.selectOptData = JSON.parse(JSON.stringify(this.selectOptData_origin))
      this.initMatchListQuery()
      console.debug(this.currCid, this.currSid, this.curTimeZoneItem)
      this.query = this.$route.query
      await this.getStageDateSports()
      if (this.matchDateArr && this.matchDateArr.length > 0) {
        await this.getScheduleMatchList()
        console.debug(this.stageArr)
        this.computedSelectOpt(this.selectOptData.configArr)
      }

      window.mixtmtBase_eventBus.$emit('loadingEvent', false)
    },
    goBackTop() {
      if (this.scrollAreaDom) {
        this.scrollAreaDom.scrollTo(0, 0)
      }
    },
    initScroll() {
      if (this.scrollAreaDom) {
        return
      }
      this.parentWidthPx = this.$refs.tableParentDom.offsetWidth
      console.debug(
        'this.parentWidthPx:',
        this.$refs.tableParentDom.scrollHeight
      )
      this.beforeScrollTop = 0
      this.threshold = 5
      this.DIRECTION_ENUM = {
        DOWN: 'down',
        UP: 'up',
      }
      window.addEventListener('resize', () => {
        this.onResizeEvent()
      })
      // this.scrollAreaDom = document.getElementsByClassName(
      //   `${this.scrollDomClassName}`
      // )[0]

      this.scrollAreaDom = document.getElementById(`${this.scrollDomById}`)

      console.debug(this.scrollAreaDom)
      this.scrollAreaDom.addEventListener('scroll', () => {
        const scrollTop = this.scrollAreaDom.scrollTop
        const scrollHeight = this.scrollAreaDom.scrollHeight
        const parentHeightPx = this.scrollAreaDom.offsetHeight
        let direction = this.DIRECTION_ENUM.DOWN
        if (this.beforeScrollTop > scrollTop) {
          direction = this.DIRECTION_ENUM.UP
        }
        // 通过滚动方向判断是触底还是触顶
        console.debug(
          'direction:',
          direction,
          scrollTop,
          parentHeightPx,
          scrollHeight,
          this.isScrollBottom
        )

        if (scrollTop > 300) {
          this.showBackTop = true
        } else {
          this.showBackTop = false
        }

        this.changeMatchLabelFixed(scrollTop, direction)
        if (direction == this.DIRECTION_ENUM.DOWN) {
          // 滚动触底
          if (scrollTop + parentHeightPx + this.threshold >= scrollHeight) {
            console.debug('滚动触底')
            this.isScrollBottom = true
          }
        } else {
          // 滚动到顶部
          this.isScrollBottom = false
          if (scrollTop <= this.threshold) {
            console.debug('滚动到顶部')
          }
        }
        this.beforeScrollTop = this.scrollAreaDom.scrollTop
      })
    },
    changeMatchLabelFixed(valPx, direction) {
      let scrollMatchItemHeightArr = this.scrollMatchItemHeightArr || []
      let curMatchLabelFixedIcon = null
      for (let i = 0; i < scrollMatchItemHeightArr.length; i++) {
        const item = scrollMatchItemHeightArr[i]
        if (item.heightPx > valPx && valPx <= item.heightPx) {
          if (item.heightPx - this.matchItemPbpx < valPx) {
            curMatchLabelFixedIcon = null
          } else {
            curMatchLabelFixedIcon = item.icon
          }
          break
        }
      }

      console.debug(
        'curMatchLabelFixed:',
        scrollMatchItemHeightArr,
        curMatchLabelFixedIcon,
        valPx,
        direction
      )
      if (this.matchTotal > 0) {
        this.curMatchLabelFixedIcon = curMatchLabelFixedIcon
      }
    },
    getScheduleMatchListDomHeigt() {
      let scrollMatchItemHeightArr = []
      let curHeightPx = 0
      const matchList = this.matchList
      matchList.forEach((item) => {
        let dom = document.getElementById(`matchList_${item.icon}`)
        curHeightPx += dom.offsetHeight //里面含paddingBottom值了
        scrollMatchItemHeightArr.push({
          icon: item.icon,
          heightPx: curHeightPx,
        })
      })
      this.curHeightPx = curHeightPx
      console.debug('getScheduleMatchListDomHeigt:', scrollMatchItemHeightArr)
      this.scrollMatchItemHeightArr = scrollMatchItemHeightArr
    },
    initPbPx() {
      this.matchItemPbpx = Math.ceil(2.78 * this.vw2px)
    },
    onResizeEvent() {
      this.initPbPx()
      if (this.$refs.tableParentDom) {
        this.parentWidthPx = this.$refs.tableParentDom.offsetWidth
      } else {
        console.debug('dom 不存在')
      }
    },
    computedSelectOpt(configArr) {
      // 组装选择框数据
      let selectOpt_list = []
      configArr.forEach((config, index) => {
        let disabledArr = []
        const mix_id = `mix_${config.origin_keyVal[0]}`
        let list = this[config.dataName].map((item) => {
          item[mix_id] = `${config.type}_${item[config.origin_keyVal[0]]}`
          return item
        })
        console.debug(
          'computedSelectOpt:',
          config.dataName,
          this[config.dataName],
          list,
          mix_id
        )
        selectOpt_list.push({
          type: config.type,
          title: config.title,
          keyVal: [mix_id, config.origin_keyVal[1]],
          curId: list[config.selectIndex][mix_id], // 选中的id,是改装后的，需要去掉前缀才是源数据的唯一id
          curVal: list[config.selectIndex][config.origin_keyVal[1]], // 这个值是源数据需要展示的值，没有做过修改
          disabledArr, //当【阶段】选择为淘汰赛时，球队这栏置灰；所以在【球队】这组对象的disabledArr=['stage_2']；而【阶段】的disabledArr = []。在marathon_select_opt组件中也需要做一些逻辑处理，主要是对curStageVal这个值
          list,
        })
      })

      this.selectOptData.selectOpt_list = selectOpt_list
      console.debug('this.selectOptData.selectOpt_list', selectOpt_list)
    },
    changeSelect(data) {
      console.debug(data)
      let valPathArr = []
      let val = data.val
      // 选择后，重置联动的筛选框
      // let updateSelectIndex = -1
      if (data.type === 'select') {
        if (val.indexOf('_') > -1) {
          valPathArr = val.split('_')
          for (let i = 0; i < this.selectOptData.selectOpt_list.length; i++) {
            let item = this.selectOptData.selectOpt_list[i]
            const idKey = item.keyVal[0]
            const valKey = item.keyVal[1]
            if (item.type == valPathArr[0]) {
              for (let j = 0; j < item.list.length; j++) {
                let cell = item.list[j]
                console.debug(idKey, val)
                if (cell[idKey] == val) {
                  console.debug(cell[idKey], val)
                  // updateSelectIndex = i
                  item.curVal = cell[valKey]
                  break
                }
              }
            }
          }
          if (valPathArr[0] === 'matchDate') {
            let selectAllObj = JSON.parse(JSON.stringify(this.selectAllObj))
            this.currStageMatchDate = valPathArr[1]
            let originDateBigSportsArr = this.originDateBigSportsArr
            originDateBigSportsArr.forEach((item, itemIndex) => {
              if (item.value === valPathArr[1]) {
                // console.debug('asdadsada:', item, valPathArr)
                item.selected = true
                this.selectOptData.configArr[0].selectIndex = itemIndex
                let bigSportsArr = item.disciplines
                  ? item.disciplines.map((ceil) => {
                      return {
                        value: ceil.disciplineCode,
                        name: ceil.disciplineName,
                      }
                    })
                  : []

                if (bigSportsArr.length > 1) {
                  this.bigSportsArr = [].concat(selectAllObj, bigSportsArr)
                } else {
                  this.bigSportsArr = bigSportsArr
                }
                this.currStageBigSports = this.bigSportsArr[0].value
              } else {
                item.selected = false
              }
            })
            this.originDateBigSportsArr = originDateBigSportsArr
            this.computedSelectOpt(this.selectOptData.configArr)
          } else if (valPathArr[0] === 'bigSports') {
            this.currStageBigSports = valPathArr[1]
          } else {
          }
          // 筛选表格逻辑
          this.initMatchListQuery()
          this.getScheduleMatchList()
        } else {
          console.debug('id命名方式不符合组件规则')
        }
      } else {
        console.debug('data.type 没有匹配成功')
      }
    },
    load() {
      console.debug('load')
      if (this.pnum > this.allPages || this.loading) {
        return
      }
      this.loading = true
      this.getScheduleMatchList()
    },
    initMatchListQuery() {
      this.pnum = 1
    },
    async getStageDateSports() {
      await https_delegation_select_dateBigSports(
        this.axiosBaseUrl,
        this.$axios,
        {
          sid: this.currSid,
          delegationId: this.query.delegationId,
          timeZone: this.curTimeZoneItem.val, // 'beijing',
        }
      )
        .then((response) => {
          const res = response.data

          if (res.status === 0) {
            let selectAllObj = JSON.parse(JSON.stringify(this.selectAllObj))
            this.originDateBigSportsArr = res.data.map((item) => {
              return {
                value: item.date,
                name: item.dateFormatter,
                disciplines: item.disciplines,
                selected: item.selected,
              }
            })
            this.matchDateArr = res.data
              ? res.data.map((item, itemIndex) => {
                  if (item.selected) {
                    this.selectOptData.configArr[0].selectIndex = itemIndex
                    this.currStageMatchDate = item.date
                    let bigSportsArr = item.disciplines
                      ? item.disciplines.map((ceil) => {
                          return {
                            value: ceil.disciplineCode,
                            name: ceil.disciplineName,
                          }
                        })
                      : []
                    if (bigSportsArr.length > 1) {
                      this.bigSportsArr = [].concat(selectAllObj, bigSportsArr)
                    } else {
                      this.bigSportsArr = bigSportsArr
                    }
                    this.currStageBigSports = this.bigSportsArr[0].value
                  }
                  return {
                    value: item.date,
                    name: item.dateFormatter,
                  }
                })
              : []

            console.debug(
              'getStageDateSports:',
              this.bigSportsArr,
              this.matchDateArr,
              this.matchDateArr.length,
              this.currStageMatchDate
            )
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
    computedMatchList(list) {
      console.debug('computedMatchList:', list)
      let matchLabelArr = this.matchLabelArr
      if (list && list.length > 0) {
        let matchList = this.matchList ? this.matchList : []
        let labelObj = {}
        list.forEach((item) => {
          let curIndex = 0
          let newItem = {}
          newItem.matchTime = item.formatTime
          newItem.matchName = `${item.disciplineName}·${item.scheduleName}`
          newItem.isChina = item.cn
          newItem.isGold = item.medalFlag === '1'
          newItem.type = item.confrontation
            ? this.sportsTypeArr[0]
            : this.sportsTypeArr[1]
          newItem.matchId = item.scheduleCode
          newItem.venueName = item.venueName
          newItem.matchStatus = item.scheduleStatus
          newItem.scheduleStatusName = item.scheduleStatusName
          newItem.sportsId = item.disciplineCode
          newItem.sportsName = item.disciplineName
          newItem.eventId = item.eventCode
          newItem.eventName = item.eventName
          newItem.scheduleName = item.scheduleName
          newItem.formatDate = item.formatDate
          newItem.formatTime = item.formatTime
          newItem.competitorType = item.competitorType
          newItem.medalist = item.medals
            ? item.medals.map((player, index) => {
                return {
                  playerId: index + 1,
                  mcompetitorType: player.mcompetitorType,
                  playerName: player.competitorName,
                  medalType: player.medalType,
                  delegationName: player.organisationName,
                  delegationLogo: player.organisationLogo,
                }
              })
            : []

          if (newItem.type === this.sportsTypeArr[0]) {
            let homeName = '',
              awayName = ''
            homeName = item.competitor1Name ? item.competitor1Name : '待定'
            awayName = item.competitor2Name ? item.competitor2Name : '待定'

            newItem.homeName = homeName
            newItem.awayName = awayName

            newItem.homeScore = item.competitor1Result
            newItem.awayScore = item.competitor2Result
          }
          newItem.homeLogo = item.organisation1Logo
          newItem.awayLogo = item.organisation2Logo
          if (matchLabelArr && matchLabelArr.length > 0) {
            curIndex = matchLabelArr.indexOf(item.disciplineCode)
          } else {
            matchLabelArr.push(item.disciplineCode)
          }
          if (curIndex > -1) {
            if (
              !labelObj ||
              !labelObj.icon ||
              labelObj.icon !== item.disciplineCode
            ) {
              labelObj = matchList[curIndex]
                ? matchList[curIndex]
                : {
                    label: item.disciplineName,
                    icon: item.disciplineCode,
                    list: [],
                  }
            }
          } else {
            console.debug('computedMatchList id:', item.disciplineCode)
            matchLabelArr.push(item.disciplineCode)
            curIndex = matchLabelArr.length - 1
            matchList.push(labelObj)
            labelObj = {
              label: item.disciplineName,
              icon: item.disciplineCode,
              list: [],
            }
          }
          labelObj.list.push(newItem)
        })
        if (labelObj.list.length > 0) {
          let curIndex = matchLabelArr.indexOf(labelObj.icon)
          if (curIndex > -1) {
            matchList[curIndex] = labelObj
          } else {
            matchList.push(labelObj)
            matchLabelArr.push(labelObj.icon)
          }
        }
        this.matchList = JSON.parse(JSON.stringify(matchList))
        this.matchLabelArr = matchLabelArr
        console.debug('computedMatchList end:', matchList, matchLabelArr)
      }
    },
    async getScheduleMatchList() {
      await https_delegationDetail_schedule(this.axiosBaseUrl, this.$axios, {
        sid: this.currSid,
        delegationId: this.query.delegationId ? this.query.delegationId : '',
        date: this.currStageMatchDate ? this.currStageMatchDate : '',
        sportsId: this.currStageBigSports
          ? this.currStageBigSports === 'all'
            ? ''
            : this.currStageBigSports
          : '',
        timeZone: this.curTimeZoneItem.val, // 'beijing',
      })
        .then((response) => {
          const res = response.data
          console.debug('response:', res)
          if (res.status === 0) {
            if (res.data) {
              this.firstPageIsScrollBottom = false
              this.matchTotal = res.data.length
              this.allPages = 1

              if (this.pnum == 1) {
                if (this.scrollAreaDom) {
                  this.scrollAreaDom.scrollTo(0, 0)
                }
                this.matchList = []
                this.matchLabelArr = []
                this.curMatchLabelFixedIcon = null
                this.initScroll()
              }

              this.computedMatchList(res.data)
            } else {
              console.debug('暂无数据')
            }
            console.debug(
              '暂无数据:',
              this.matchTotal,
              this.matchList,
              this.matchList.length
            )
            if (this.matchTotal === 0) {
              this.matchList = []
            } else {
              // this.$nextTick(() => {
              //   this.loading = false
              //   this.getScheduleMatchListDomHeigt()
              // })
              // 第一页就不够数据的
              this.$nextTick(() => {
                this.loading = false
                this.getScheduleMatchListDomHeigt()
                if (
                  this.$refs.tableParentDom.offsetHeight >=
                  Math.floor(this.curHeightPx)
                ) {
                  // this.isScrollBottom = true
                  this.firstPageIsScrollBottom = true
                }
                console.debug(
                  'getParentHeightPx:',
                  this.$refs.tableParentDom.offsetHeight,
                  this.curHeightPx,
                  this.isScrollBottom,
                  this.matchTotal
                )
              })
            }
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
  },
}
</script>

<style lang="scss" scoped>
#compreSportsMeet_schedule {
  &.isShow {
    padding-top: 3.125vw;
  }
  .select_area {
    position: relative;
    padding-top: 2.778vw;
    width: 100%;
    height: 9.028vw;
    .switch_area {
      position: absolute;
      top: 2.778vw;
      right: 0;
      z-index: 10;
    }
  }

  .teamTable {
    padding: 2.778vw 0 6.964vw;
    .tableScrollArea {
      position: relative;
      .match_label_fixed {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 100;
        width: 100%;
        height: 3.472vw;
        background-color: var(--mixtmt_whiteColor);
        .match_label {
          width: 100%;
          height: 3.472vw;
          background-image: var(--mixtmt_scheduleMatchList_dateBg);
          background-size: 100% auto;
          background-position: left top;
          background-repeat: no-repeat;

          .label_textArea {
            position: absolute;
            left: 0;
            top: 50%;
            z-index: 2;
            transform: translateY(-50%);
            width: 21.55%;
            font-size: 1.38vw;
            color: var(--mixtmt_whiteColor);
            display: flex;
            display: -webkit-flex;
            justify-content: center;
            align-items: center;
            .labelIcon {
              width: 2.778vw;
              height: 2.778vw;
              border: 1.5px solid var(--mixtmt_whiteColor);
              border-radius: 50%;
              overflow: hidden;
              margin-right: 0.694vw;
              img {
                display: block;
                width: 100%;
                height: 100%;
                object-fit: contain;
              }
            }
            & .letterSpa {
              letter-spacing: 0.4vw;
            }
          }
        }
      }
      /* .scrollDomContain {
        max-height: calc(100vh - 19.142vw);
        overflow: auto;
      } */
    }
  }

  .loadingClass,
  .noMoreClass,
  .noDataClass {
    position: absolute;
    bottom: -4.166vw;
    left: 0;
    z-index: 2;
    width: 100%;
    line-height: 4.166vw;
    text-align: center;
    font-size: 0.972vw;
    color: var(--mixtmt_greyColor2);
  }
  .noDataClass {
    border-top: 1px solid var(--mixtmt_greyColor0);
    border-bottom: 1px solid var(--mixtmt_greyColor0);
  }
}
</style>
